import React from "react";
import styled from "styled-components";
import { IconClipboard, IconKnowledge, IconPhoneAid } from "@upsolve/ui";

import Logo from "../../../static/images/upsolve-logo.svg";

const MockLaptop = (props) => {
  return (
    <StyledLaptopDemo cssOverrides={props.cssOverrides}>
      <span className="laptop__shadow"></span>
      <span className="laptop__lid"></span>
      <span className="laptop__camera"></span>
      <div className="laptop__screen">
        <div className="laptop__screen__header">
          <Logo />
        </div>
        <div className="laptop__screen__checklist">
          <div className="laptop__screen__checklist__step">{props.children}</div>
        </div>
        <div className="laptop__screen__footer">
          <IconClipboard />
          <IconPhoneAid />
          <IconKnowledge />
        </div>
      </div>
      <span className="laptop__chassis">
        <span className="laptop__keyboard"></span>
        <span className="laptop__trackpad"></span>
      </span>
    </StyledLaptopDemo>
  );
};

const StyledLaptopDemo = styled.figure`
  position: relative;
  width: 584px;
  height: 405px;
  left: 50%;
  margin-left: -292px;
  user-select: none;

  // STRUCTURE
  & > * {
    position: absolute;
  }
  .laptop__shadow {
    left: 17px;
    right: 17px;
    top: 40px;
    height: 490px;
    opacity: 0.3;
    filter: alpha(opacity=30);
    background: #7692b3;
    filter: blur(30px);
  }
  .laptop__lid {
    width: 100%;
    height: 100%;
    background: linear-gradient(45deg, #e5ebf2, #f3f8fb);
    border-radius: 20px;
    box-shadow: inset 1px -4px 6px rgba(145, 161, 181, 0.3);
  }
  .laptop__camera {
    --size: 4px;
    width: var(--size);
    height: var(--size);
    top: 10px;
    left: 50%;
    margin-left: calc(var(--size) / -2);
    border-radius: 50%;
    background: #dae0e8;
  }
  .laptop__chassis {
    width: 100%;
    height: 142px;
    top: calc(100% - 11px);
    border-radius: 8px 8px 14px 14px;
    transform: perspective(880px) rotateX(40deg);
    transform-origin: 50% 0;
    background: linear-gradient(rgba(145, 161, 181, 0.2), rgba(145, 161, 181, 0)),
      linear-gradient(45deg, #e5ebf2, #f3f8fb);
    box-shadow: inset 0 -2px 3px rgba(145, 161, 181, 0.5), inset -1px -6px 4px rgba(253, 255, 255, 0.9);
    & * {
      opacity: 0.3;
      filter: alpha(opacity=30);
      background: linear-gradient(45deg, #b2bdcc, #c1ccd8);
      box-shadow: 1px 1px 1px hsla(0, 0%, 100%, 0.75);
      position: absolute;
    }
    .laptop__keyboard {
      left: 28px;
      right: 28px;
      top: 12px;
      height: 62px;
      border-radius: 2px 2px 4px 4px;
    }
    .laptop__trackpad {
      left: 165px;
      right: 165px;
      top: 76px;
      height: 52px;
      border-radius: 4px 4px 6px 6px;
    }
  }
  .laptop__screen {
    top: 24px;
    bottom: 35px;
    left: 17px;
    right: 17px;
    border-radius: 4px;
    box-shadow: -1px 1px 6px rgba(171, 183, 204, 0.2);
    background: #fff;
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  // SCREEN
  .laptop__screen__checklist {
    width: 100%;
    height: 100%;
    padding: 0;
  }
  .laptop__screen__checklist__step {
    height: 100%;
    width: 100%;
    max-width: 60%;
    margin: 0 auto;
    padding: 1em 0;
    display: flex;
    flex-direction: column;
    text-align: center;
    span {
      color: ${(props) => props.theme.colors.brand[500]};
    }
    .video-previewer {
      margin: 0.25em 0;
      border-radius: 8px;
      border: 6px solid ${(props) => props.theme.colors.brand[500]};
      overflow: hidden;
    }
  }
  .laptop__screen__header,
  .laptop__screen__footer {
    background: white;
    width: 100%;
    height: 40px;
    border-bottom: 1px solid ${(props) => props.theme.colors.white[500]};
    padding: 0 1em;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 5;
    svg {
      height: 18px;
      width: auto;
      path {
        fill: ${(props) => props.theme.colors.brand[700]};
      }
    }
  }
  .laptop__screen__footer {
    height: 64px;
    border-bottom: 0;
    border-top: 1px solid ${(props) => props.theme.colors.white[500]};
    align-items: flex-start;
    justify-content: center;
    svg {
      height: 28px;
      margin: 12px 24px;
      path {
        fill: ${(props) => props.theme.colors.white[100]};
      }
    }
  }
`;

export default MockLaptop;
